var React = require('react');

function Lastfm (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M28.016,8.843c-1.433,1.827-2.619-0.546-4.208-0.526c-1.359,0.016-2.522,0.775-2.456,2.453\r\n\t\tc0.117,2.793,6.551,2.855,7.891,5.085c3.289,5.465-4.921,10.204-9.289,6.66c-2.729-2.214-2.822-6.917-5.435-11.043\r\n\t\tC11.265,6.336,2.944,8.213,2.422,14.278c-0.67,7.814,9.53,9.44,12.097,3.68c0.587,0.64,0.702,1.75,1.227,2.455\r\n\t\tc-5.004,6.503-14.629,2.463-15.601-3.681c-1.682-10.607,11.742-13.714,16.3-6.663c0.963,1.485,1.832,3.894,2.631,5.787\r\n\t\tc0.754,1.783,1.242,4.447,2.98,5.258c1.803,0.838,5.584,0.132,5.435-2.805c-0.15-2.97-6.878-3.024-8.064-5.609\r\n\t\tC16.544,6.419,27.252,3.967,28.016,8.843z"})));
}

Lastfm.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 30.001 30.001","style":{"enableBackground":"new 0 0 30.001 30.001"},"xmlSpace":"preserve"};

module.exports = Lastfm;

Lastfm.default = Lastfm;
